const TITLE_TEMPLATE = '%t | Portal'

export interface MetadataProps {
  title?: string
  description?: string
}

export const Metadata: React.FC<MetadataProps> = ({ title }) => {
  const generateTitle = (title: string, titleTemplate: string) => {
    return titleTemplate.replace('%t', title)
  }

  return <>{title && <title>{generateTitle(title, TITLE_TEMPLATE)}</title>}</>
}
